export default "__VITE_ASSET__CM$vKhlO__"